// ============================================================
// audio/musicChill.js — MP3 background music player
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';
import { initAudio } from './context.js';

/** Start the MP3 background music track. Idempotent — never restarts
 *  from scratch if the track is already playing. */
export function startMusic() {
  initAudio();
  if (state.audioCtx.state === 'suspended') state.audioCtx.resume();
  dom.bgMusic.volume = state.musicVolume;
  // If track is already running, just keep it going — don't restart the song
  if (state.musicPlaying && !dom.bgMusic.paused && !dom.bgMusic.ended) {
    return;
  }
  // If it was paused in place, resume from where it was. Only reset to 0
  // if we've never played or the track naturally ended.
  if (dom.bgMusic.ended) dom.bgMusic.currentTime = 0;
  dom.bgMusic.play().catch(() => {});
  state.musicPlaying = true;
}

/** Stop all music playback and disconnect procedural nodes. */
export function stopMusic() {
  state.musicPlaying = false;
  state.darkMusicPlaying = false;
  state.ogMusicPlaying = false;
  dom.bgMusic.pause();
  state.musicNodes.forEach(n => { try { n.disconnect(); } catch(e){} });
  state.musicNodes = [];
}
